"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useActionEffect = void 0;
var react_1 = require("react");
var middleware_1 = require("./middleware");
/**
 * Special useEffect to trigger callback when specific redux action is fired;
 * unsubscribes on component unload
 */
var useActionEffect = function (actionToWatch, callback) {
    (0, react_1.useEffect)(function () {
        var actionTypeSubscription = middleware_1.actionTypeSubject$.subscribe(function (action) {
            if (action.type === actionToWatch.type) {
                callback(action);
            }
        });
        return function () {
            actionTypeSubscription.unsubscribe();
        };
    }, []);
};
exports.useActionEffect = useActionEffect;
//# sourceMappingURL=hook.js.map